export const ROOT_URL = 'http://srvc.mydinestein.com/api/';
//export const ROOT_URL = 'http://localhost:5000/api/';

let reduxStore = null;

export const PageBkColor = "#77AA77";

export function SetPageBKColor() {
  document.body.style.backgroundColor = "#77AA77";
}

export function SetPageBKColorWht() {
  document.body.style.backgroundColor = "#FFFFFF";
}

export function getReduxStore()
{
    return reduxStore;
}

export function setReduxStore(store)
{
    reduxStore = store;
}

export function buildPrepTime(ttlmins) {
  var tmstr;

  const mins = ttlmins % 60;
  const hours = Math.floor(ttlmins / 60);

  if (hours < 1) {
    tmstr = "";
  }
  else if (hours === 1)
  {
    tmstr = "1 hr";
  }
  else {
    tmstr = hours + " hrs";
  }

  if (mins > 0)
  {
    if (mins === 1)
    {
      tmstr = tmstr + " 1 min";
    }
    else {
      tmstr = tmstr + " " + mins + " mins";
    }
  }

  return tmstr;

}

export function displayUnits(qty) {

  const qtyStr = qty.toString();

  if (qtyStr.includes('.')) {
    var n = ("" + qtyStr).split('.').map(Number);
    var d = '';

    switch (n[1]) {

      case 25:
        d = "1/4";
        break;

      case 5:
        d = "1/2";
        break;

      case 75:
        d = "3/4";
        break;

      case 125:
        d = "1/8";
        break;

      case 33:
        d = "1/3";
        break;
  
      case 625:
        d = "1/16";
        break;
  
      default:
        d = n.toString();
    }

    if (n[0] > 0) {
      return n[0].toString() + " " + d;
    }
    else {
      return d;
    }
  } 
  else {
    return qtyStr;
  }

}




// WEBPACK FOOTER //
// ./src/globals.js